import { render, staticRenderFns } from "./Viaticos.vue?vue&type=template&id=5aed758f&"
import script from "./Viaticos.vue?vue&type=script&lang=js&"
export * from "./Viaticos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports